namespace $ {
	export function $mol_base64_encode(src: string | Uint8Array): string {
		throw new Error('Not implemented')
	}
}
